const Role = `
  id
  name
  permissions
  permissionSet
  usersCount
`;

export default Role;
